import { APP_ROOT_ELEMENT_ID } from './constants-generated';

/**
 * Entrypoint of this Client App. Checks if exists root element by provided ID and renders.
 */
const init = async () => {
  const rootElement = document.getElementById(APP_ROOT_ELEMENT_ID);
  if (rootElement) {
    const appRender = await import('./AppRender');
    await appRender.render(rootElement);
  } else {
    throw new Error(`Element #${APP_ROOT_ELEMENT_ID} was not found!`);
  }
};
init().catch(error => {
  throw error;
});